import api from '../../api/axios';

export const VOICE_TOGGLE_REQUEST = 'VOICE_TOGGLE_REQUEST';
export const VOICE_TOGGLE_SUCCESS = 'VOICE_TOGGLE_SUCCESS';
export const VOICE_TOGGLE_FAILURE = 'VOICE_TOGGLE_FAILURE';
export const VOICE_RESET = 'VOICE_RESET';

export const toggleVoiceMode = (textOnly, userId = null) => async (dispatch) => {
  dispatch({ type: VOICE_TOGGLE_REQUEST });
  
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('No authentication token found');
    }

    // Prepare request body
    const requestBody = {
      textOnly: textOnly
    };
    
    // Include userId if provided
    if (userId) {
      requestBody.userId = userId;
    }

    // Call API to toggle voice mode
    const response = await api.post(`conversation/textOnlyModeOnOff`, requestBody, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    const envelope = response?.data || {};
    if (envelope.success) {
      dispatch({
        type: VOICE_TOGGLE_SUCCESS,
        payload: { 
          textOnly: envelope.data?.textOnly || textOnly,
          message: envelope.message || 'Voice mode updated successfully'
        }
      });
      return { 
        success: true, 
        textOnly: envelope.data?.textOnly || textOnly,
        message: envelope.message || 'Voice mode updated successfully'
      };
    } else {
      throw new Error(envelope.message || 'Failed to toggle voice mode');
    }
  } catch (error) {
    dispatch({
      type: VOICE_TOGGLE_FAILURE,
      error: error.message || 'Failed to toggle voice mode'
    });
    return { success: false, error: error.message };
  }
};

export const resetVoiceState = () => ({
  type: VOICE_RESET
});
